import { Col, DatePicker, Row, Select, Space, Typography } from 'antd';
import InspectionAQL from 'app/components/Form/Controlled/AQL';
import Panel from 'app/components/Layout/Panel';
import {
  inspectionType,
  inspectionLevel
} from 'app/providers/StaticProvider/options';
import { Field } from 'formik';
import moment from 'moment';
import React from 'react';
import classes from './Style.module.scss';

const Edit = () => {
  return (
    <Panel className={classes.inspectionRequirementEdit}>
      <div className={classes.container}>
        <div className={classes.block}>
          <Row gutter={[16, 16]} wrap>
            <Col sm={24} lg={8}>
              <Space
                direction="vertical"
                className={classes.fullWidth}
                size={24}
              >
                <Typography.Title className={classes.subTitle} level={4}>
                  Inspection Date
                </Typography.Title>
                <Field name="inspectionRequirement.inspectionDate">
                  {({ field }) => {
                    return (
                      <DatePicker
                        format="DD/MM/YYYY"
                        placeholder="Select Date"
                        value={
                          !field.value
                            ? null
                            : moment(field.value, 'DD/MM/YYYY')
                        }
                        onBlur={field.onBlur}
                        onChange={(_, dateString) => {
                          field.onChange({
                            target: {
                              name: 'inspectionRequirement.inspectionDate',
                              value: dateString
                            }
                          });
                        }}
                      />
                    );
                  }}
                </Field>
              </Space>
            </Col>
            <Col sm={24} lg={8}>
              <Space
                direction="vertical"
                className={classes.fullWidth}
                size={24}
              >
                <Typography.Title className={classes.subTitle} level={4}>
                  Inspection Type
                </Typography.Title>
                <Field name="inspectionRequirement.typeOfService">
                  {({ field }) => {
                    return (
                      <Select
                        options={inspectionType}
                        placeholder="Select here"
                        value={field.value}
                        onBlur={field.onBlur}
                        onChange={(option) => {
                          field.onChange({
                            target: {
                              name: 'inspectionRequirement.typeOfService',
                              value: option
                            }
                          });
                        }}
                      />
                    );
                  }}
                </Field>
              </Space>
            </Col>
            <Col sm={24} lg={8}>
              <Space
                direction="vertical"
                className={classes.fullWidth}
                size={24}
              >
                <Typography.Title className={classes.subTitle} level={4}>
                  Inspection Level
                </Typography.Title>
                <Field name="inspectionRequirement.generalInspectLevel">
                  {({ field }) => {
                    return (
                      <Select
                        placeholder="Select here"
                        options={inspectionLevel}
                        value={field.value}
                        onBlur={field.onBlur}
                        onChange={(option) => {
                          field.onChange({
                            target: {
                              name: 'inspectionRequirement.generalInspectLevel',
                              value: option
                            }
                          });
                        }}
                      />
                    );
                  }}
                </Field>
              </Space>
            </Col>
          </Row>
        </div>
        <InspectionAQL
          helperText="This AQL applies to all products in this job by default."
          fieldNames={{
            critical: 'inspectionRequirement.criticalLevel',
            minor: 'inspectionRequirement.criticalMinorLevel',
            major: 'inspectionRequirement.criticalMajorLevel'
          }}
        />
      </div>
    </Panel>
  );
};

export default Edit;
